import React, {Component} from 'react'
import OtpInput from "react-otp-input";
import styles from '../styles/otp.module.css'
import { number } from 'yup';

export default class Otp extends Component {
  state = { otp: "" };

  handleChange = (otp) => this.setState({ otp });

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.otp}>
          <OtpInput
            value={this.state.otp}
            onChange={this.handleChange}
            inputStyle={styles.inputStyle}
            numInputs={5}
            separator={<span></span>}
          />
        </div>
        <p className={styles.resend}>
          <a href="#">Resend code</a>
        </p>
        <button className={styles.submit}>Done</button>

        <p className={styles.login}>
            Already have an account? <span><a href="./login">Log in</a></span>
        </p>
      </div>
    );
  }
}